import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import React, { Component } from 'react';
import { defineMessages, FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import ActionButton from "../common/button/actionbutton.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import CustomerSelect from "../customer/selection.component.jsx";
import Integrations from "../integration/Integrations.jsx";
import LocationSelect from "../integration/LocationSelect";
import PaymentTypeIcon from "../invoice/paymenttypeicon.component.jsx";
import PaymentLink from "../payment/components/PaymentLink";
import PaymentExternalDetails from "../payment/externaldetails.component.jsx";
import PaymentTypeLabel from "../payment/label.component.jsx";
import EventInfoBlock from "../quote/analytics/events/Utils/EventInfoBlock";
import { BILLING_TYPE } from '../state/invoice/InvoiceBillingType';
import LocationService from "../state/location/LocationService";
import CreditMemoStatusBadge from "./creditmemostatus.component.jsx";


const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    "notes_placeholder": {
        id: 'invoice.credit_memo_modal.notes_placeholder',
        defaultMessage: 'Describe a reason that customer will see on their statements',
    },
    "internal_notes_placeholder": {
        id: 'invoice.credit_memo_modal.internal_notes_placeholder',
        defaultMessage: 'Enter an internal notes to describe the reason or the situation.',
    },
})

class EditCreditMemoModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            contactId: this.props.contactId || null,
            creditMemo: null,
            creditMemoId: this.props.creditMemoId || null,
            className: this.props.className || '',
            modalId: this.props.modalId || 'edit-credit-memo-modal-' + uuidv4(),
            notes: '',
            selectedLocation: {},
            locations: [],
            loadingLocations: true,
            internalNotes: '',
            invoiceId: '',
            quoteId: '',
            identifier: '',
            returnIdentifier: '',
            quoteIdentifier: '',
            orderIdentifier: '',
            status: '',
            amount: '0',
            remainingAmount: '0',
            links: [],
            currency: AppContext.getAccount().attributes.currency,
            redirect: false,
            appliedReferences: [],
            readOnly: this.props.readOnly || false,
            creditMemoOriginalPayment: null,
            isArchived: false,
            hideDeleteButton: this.props.hideDeleteButton || false,
            onRefresh: this.props.onRefresh || function () { },
        }
        this.closeModalAndRefund = this.closeModalAndRefund.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.closeModalAndRedirect = this.closeModalAndRedirect.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.remove = this.remove.bind(this)
        this.unarchiveCreditMemo = this.unarchiveCreditMemo.bind(this)
        this.exportIntegration = this.exportIntegration.bind(this)
        this.showRefundButton = this.showRefundButton.bind(this)
        this.handleCustomerChange = this.handleCustomerChange.bind(this)
        this.handleSelectChange = this.handleSelectChange.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
        })
    }

    componentDidMount() {
        AppContext.getApiClient().get('/credit-memos/' + this.state.creditMemoId).then(res => {
            this.setState({
                creditMemo: res,
                identifier: res.attributes.identifier,
                invoiceId: res.attributes.invoiceReferenceId,
                quoteId: res.attributes.quoteReferenceId,
                orderId: res.attributes.orderReferenceId,
                status: res.attributes.status,
                amount: res.attributes.amount,
                remainingAmount: res.attributes.remainingAmount,
                notes: res.attributes.notes,
                internalNotes: res.attributes.internalNotes,
                links: res.attributes.externalLinks,
                creditMemoType: res.attributes.type,
                creditMemoOriginalPayment: res.attributes.payment,
                isArchived: res.attributes.isArchived,
                proposalHash: res.attributes.proposalHash,
                contactId: res.attributes.contactId,
                selectedLocation: res.attributes.locationId
            })

            const includeArchived = true
            LocationService.fetchAllLocations(includeArchived).then(res => {
                this.setState({
                    locations: res,
                    isLoadingLocations: false
                })
            })

            if (this.state.invoiceId) {
                AppContext.getApiClient().get('/invoices/' + this.state.invoiceId).then(res => {
                    if (res && res.attributes.billingType === BILLING_TYPE.RETURN) {
                        this.setState({
                            returnIdentifier: res.attributes.identifier,
                        })
                    }
                })
            }
            if (this.state.quoteId) {
                AppContext.getApiClient().get('/quotes/' + this.state.quoteId).then(res => {
                    if (res) {
                        this.setState({
                            quoteIdentifier: res.attributes.identifier,
                        })
                    }
                })
            }
            if (this.state.orderId) {
                AppContext.getApiClient().get('/orders/' + this.state.orderId).then(res => {
                    if (res) {
                        this.setState({
                            orderIdentifier: res.attributes.identifier,
                        })
                    }
                })
            }
            if (this.state.proposalHash) {
                AppContext.getApiClient().get('/proposals/' + this.state.proposalHash).then(res => {
                    if (!res.error) {
                        this.setState({
                            proposal: res,
                        })
                    }
                })
            }

            this.getAppliedReferences()
        })
        $('#' + this.state.modalId).modal('show')
    }

    // return an array of invoices and quotes on which a payment was made with the current credit memo
    getAppliedReferences() {
        let postData = {
            keywords: '*',
            objects: ['invoices', 'quotes', 'orders'],
            fields: ['identifier'],
            pageSize: 1000,
            activePage: 1,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                "{oneOf}": {
                    transactionPaymentsUniqueRefundCreditMemoId: [this.state.creditMemoId],
                    transactionPaymentsUniqueCreditMemoId: [this.state.creditMemoId],
                }
            },
            lightResult: true,
        }
        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            Promise.all(r.data.map(item => AppContext.getApiClient().get(`/${item._type}/${item.id}`))).then(items => {
                this.setState({
                    appliedReferences: items.map(item => {
                        let paymentTransactions = item.attributes.paymentTransactions.filter(p => {
                            return p.attributes.payment.attributes.creditMemoId === this.state.creditMemoId ||
                                p.attributes.payment.attributes.refundCreditMemoId === this.state.creditMemoId
                        })
                        return {
                            identifier: item.attributes.identifier,
                            id: item.id,
                            objectType: item.type,
                            paymentTransactions,
                        }
                    }).filter(item => item.paymentTransactions.length > 0)
                })
            })
        })
    }

    closeModal(event) {
        event?.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    closeModalAndRedirect(objectId, objectType) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(objectId, objectType)
        }
    }

    closeModalAndRefund() {
        $('#' + this.state.modalId).modal('hide')
        setTimeout(() => {
            this.props.onCloseForRefund(this.state.identifier, this.state.currency, this.state.remainingAmount)
        }, 150)
    }

    handleCustomerChange(contactId) {
        if (!contactId) {
            return
        }
        this.setState({
            contactId: contactId
        })
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    submit(e) {
        e.preventDefault()
        AppContext.getApiClient().patch('/credit-memos/' + this.state.creditMemoId, {
            contactId: this.state.contactId,
            notes: this.state.notes,
            internalNotes: this.state.internalNotes,
            locationId: this.state.selectedLocation.value
        }).then(res => {
            if (!res.error) {
                this.closeModal()
            }
        })
    }

    remove(e) {
        e.preventDefault()
        AppContext.getApiClient().delete('/credit-memos/' + this.state.creditMemoId).then(res => {
            if (!res.error) {
                this.closeModal()
            }
        })
    }

    unarchiveCreditMemo(e) {
        e.preventDefault()
        AppContext.getApiClient().put(`/credit-memos/${this.state.creditMemoId}/unarchive`, {}).then(res => {
            if (!res.error) {
                this.closeModal()
                this.state.onRefresh()
            }
        })
    }

    exportIntegration(event) {
        event.preventDefault()
        return AppContext.getApiClient().post(`/staff/credit-memos/${this.state.creditMemoId}/export`, {}).then(_ => {
            this.closeModal()
        })
    }

    getModalTitle() {
        switch (this.state.creditMemoType) {
            case 'deposit':
                return <FormattedMessage
                    id="invoice.edit_credit_memo_modal.deposit_title"
                    defaultMessage="Deposit {identifier}"
                    values={{
                        identifier: this.state.identifier
                    }}
                />
            default:
                return <FormattedMessage
                    id="invoice.edit_credit_memo_modal.title"
                    defaultMessage="Credit memo {identifier}"
                    values={{
                        identifier: this.state.identifier
                    }}
                />
        }
    }

    getTransactionHeaders() {
        return [
            <FormattedMessage
                id="credit_memos.history.list.headers.identifier_label"
                defaultMessage="ID"
            />,
            <FormattedMessage
                id="credit_memos.history.list.headers.date_label"
                defaultMessage="Transaction date"
            />,
            <FormattedMessage
                id="credit_memos.history.list.headers.amount_applied_label"
                defaultMessage="Amount applied"
            />,
        ]
    }

    getTransactionRows() {
        return this.state.appliedReferences.map((reference, i) => {
            return [
                <a key={i} href={'#'} className="mr-2"
                    onClick={() => this.closeModalAndRedirect(reference.id, reference.objectType)}>
                    {reference.identifier}
                </a>,
                <div>
                    {reference.paymentTransactions.filter(p => p.attributes.status === "paid")
                        .map((p, i) => {
                            return <div key={i}>
                                <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    value={new Date(p.attributes.createdAt)} />
                            </div>
                        })}
                </div>,
                <div>
                    {reference.paymentTransactions.filter(p => p.attributes.status === "paid")
                        .map((p, i) => {
                            return <div key={i}>
                                < FormattedNumber
                                    style="currency"
                                    currency={p.attributes.currency}
                                    value={p.attributes.amount}
                                />
                            </div>
                        })
                    }</div>,
            ]
        })
    }

    getPaymentTypeIcon() {
        const payment = this.state.creditMemoOriginalPayment

        return payment.attributes.paymentType ?
            payment.attributes.paymentType.attributes.icon : ''
    }

    displayCreditMemoOriginalPaymentType() {
        const payment = this.state.creditMemoOriginalPayment

        return <div className={'mr-5 align-self-center'}>
            <label className="col-form-label custom-form-label pt-0">
                <strong>
                    <PaymentTypeLabel standalone={true} nameOnly={true} value={payment.attributes.type} />
                </strong>
            </label>
            <h2 className={"m-0 d-flex justify-content-center"}>
                <PaymentTypeIcon
                    value={this.state.creditMemoOriginalPayment.attributes.type}
                    icon={this.getPaymentTypeIcon()}
                />
            </h2>
        </div>
    }

    displayPaymentAmount() {
        const payment = this.state.creditMemoOriginalPayment

        return <div className={'mr-5'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label pt-0">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.payment_amount_spent"
                            defaultMessage="Payment amount"
                        />
                    </strong>
                </label>
            </div>
            <h4 className={"m-0 " + (this.state.isDeleted ? 'text-danger' : '')}>
                <FormattedNumber
                    value={payment.attributes.amount}
                    style={'currency'}
                    currency={payment.attributes.currency}
                />
            </h4>
        </div>
    }

    displayPaymentDate() {
        const payment = this.state.creditMemoOriginalPayment

        return <div className={'mr-3'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label pt-0">
                    <strong>
                        {
                            payment.attributes.capturedAt ?
                                <FormattedMessage
                                    id="invoice.analytics.events.payment_received.captured_at"
                                    defaultMessage="Received on"
                                />
                                :
                                <FormattedMessage
                                    id="invoice.analytics.events.payment_received.imported_at"
                                    defaultMessage="Captured on"
                                />
                        }
                    </strong>
                </label>
            </div>
            <h4 className={"m-0 "}>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(payment.attributes.capturedAt || payment.attributes.createdAt)} />
            </h4>
        </div>
    }

    displayReceiptButton() {
        return <div className={'mr-5 mt-2'}>
            {
                this.state.creditMemoOriginalPayment &&
                this.state.proposal && this.state.proposal.attributes && this.state.proposal.attributes.publicLink &&
                <a type="button" class="btn btn-sm btn-outline-primary"
                    href={this.state.proposal.attributes.publicLink} target="_blank">
                    <FormattedMessage
                        id="invoice.analytics.events.payment_receipt.label"
                        defaultMessage="Open Receipt"
                    />
                </a>
            }
        </div>
    }

    displayPaymentLink() {
        const pay = this.state.creditMemoOriginalPayment
        if (!pay) {
            return ""
        }

        return <EventInfoBlock
            label={<FormattedMessage
                id="common.payment_id.label"
                defaultMessage="Payment ID"
            />}
            info={<h4>
                <div onClick={(e) => {
                    e.preventDefault()
                    this.closeModal()
                }}>
                    <PaymentLink
                        paymentId={pay.id}
                        label={pay.attributes.identifier}
                    />
                </div>
            </h4>}
        />
    }

    displayCreditMemoOriginalPaymentInformation() {
        return <div className={'col-12 d-flex align-items-center flex-wrap'}>
            {
                this.displayCreditMemoOriginalPaymentType()
            }
            {
                this.displayPaymentLink()
            }
            {
                this.displayPaymentAmount()
            }
            {
                this.displayPaymentDate()
            }
            {
                this.displayReceiptButton()
            }
            {
                this.state.creditMemoOriginalPayment.attributes.externalLink ?
                    <div className={'col-12 border-top pt-2 mt-2'} >
                        <div className={'w-100'}>
                            <p className={'mb-2'}>
                                <FormattedMessage
                                    id="invoice.analytics.events.payment_received_exported.integration"
                                    defaultMessage="This payment was made with {integrationName}"
                                    values={{
                                        integrationName: Integrations.getIntegrationNameFromKey(this.state.creditMemoOriginalPayment.attributes.externalLink.attributes.integrationKey)
                                    }}
                                />
                            </p>
                        </div>
                        <PaymentExternalDetails value={this.state.creditMemoOriginalPayment} />
                    </div> : ''
            }
        </div>
    }

    showActionButtons(isArchived) {

        return !isArchived && <>
            {(AppContext.getUserLoggedIn().attributes.superUser || this.state.links.length == 0) &&
                !this.state.hideDeleteButton &&
                <ActionButton
                    type="button"
                    className="btn btn-danger"
                    onClick={this.remove}
                >
                    <FormattedMessage
                        id="invoice.credit_memo_modal.delete_btn"
                        defaultMessage="Delete credit memo"
                    />
                </ActionButton>
            }
            {this.showRefundButton(isArchived)}
        </>

    }

    showRefundButton(isArchived) {
        return !isArchived &&
            <>
                {this.state.remainingAmount > 0 &&
                    <span className={'pl-2'}>
                        <ActionButton
                            type="button"
                            className="btn btn-warning"
                            onClick={this.closeModalAndRefund}>
                            <FormattedMessage
                                id="invoice.credit_memo_modal.refund_btn"
                                defaultMessage="Refund"
                            />
                        </ActionButton>
                    </span>
                }</>
    }

    handleSelectChange(location) {
        const selectedLocation = this.state.locations?.find(loc => loc.getId() === location.value)

        if (selectedLocation?.isDeleted() || !selectedLocation?.getEnabled()) {
            return
        }

        this.setState({
            selectedLocation: location
        })
    }

    render() {
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="emailModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="emailModalTitle">
                            <Icon value={'file-invoice-dollar'} className={'mr-2'} />
                            {this.getModalTitle()}
                            <CreditMemoStatusBadge className={'ml-1'} status={this.state.status} />
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="container-fluid">
                            {
                                this.state.creditMemo &&
                                <div className="form-group row mb-3">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2"
                                        htmlFor="contact">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.contact_label"
                                            defaultMessage="Contact"
                                        />
                                    </label>

                                    {!GlobalHelper.canReplaceCustomerInCreditMemo(this.state.creditMemo) ?
                                        <div className="col-12 col-md-10 d-flex align-items-center">
                                            <span>{this.state.creditMemo.attributes.contactName}</span>
                                        </div> :
                                        <div className="col-12 col-md-10">
                                            <CustomerSelect
                                                id={'contactId'}
                                                name={'contactId'}
                                                contactType={'persons'}
                                                value={this.state.contactId}
                                                onChange={this.handleCustomerChange}
                                            />
                                        </div>
                                    }
                                </div>
                            }
                            {this.state.locations.length > 0 && <div className="form-group row mb-3">
                                <label className="col-12 col-md-2  col-form-label custom-form-label pb-2"
                                    htmlFor="notes">
                                    <FormattedMessage
                                        id="invoice.credit_memo_modal.location_label"
                                        defaultMessage="Location"
                                    />
                                </label>
                                <div className="col-12 col-md-10">
                                    <LocationSelect
                                        selectedLocationIds={this.state.selectedLocation}
                                        isLoadingLocations={this.state.isLoadingLocations}
                                        locations={this.state.locations}
                                        multi={false}
                                        onSelect={
                                            this.handleSelectChange
                                        }
                                    />
                                </div>
                            </div>}
                            <div className="form-group row mb-3">
                                <label className="col-12 col-md-2  col-form-label custom-form-label pb-2"
                                    htmlFor="notes">
                                    <FormattedMessage
                                        id="invoice.credit_memo_modal.notes_label"
                                        defaultMessage="Notes"
                                    />
                                </label>
                                <div className="col-12 col-md-10">
                                    <input
                                        className="form-control"
                                        id="notes"
                                        name="notes"
                                        value={this.state.notes}
                                        onChange={this.handleFormChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(messages["notes_placeholder"])}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-3">
                                <label className="col-12 col-md-2  col-form-label custom-form-label pb-2"
                                    htmlFor="internalNotes">
                                    <FormattedMessage
                                        id="invoice.credit_memo_modal.internal_notes_label"
                                        defaultMessage="Internal notes"
                                    />
                                </label>
                                <div className="col-12 col-md-10">
                                    <textarea
                                        className="form-control"
                                        id="internalNotes"
                                        name="internalNotes"
                                        value={this.state.internalNotes}
                                        onChange={this.handleFormChange}
                                        rows="2"
                                        placeholder={this.props.intl.formatMessage(messages["internal_notes_placeholder"])}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-0">
                                <label className="col-12 col-md-2  col-form-label custom-form-label pb-2"
                                    htmlFor="amount">
                                    <FormattedMessage
                                        id="invoice.credit_memo_modal.amount_label"
                                        defaultMessage="Amount"
                                    />
                                </label>
                                <div className="col-12 col-md-10 d-flex align-items-center">
                                    <FormattedNumber
                                        value={this.state.amount}
                                        currency={this.state.currency}
                                        style={'currency'}
                                    />
                                </div>
                            </div>
                            {
                                this.state.status === 'partially-applied' ? <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.amount_left_label"
                                            defaultMessage="Amount left"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10 d-flex align-items-center">
                                        <FormattedNumber
                                            value={this.state.remainingAmount}
                                            currency={this.state.currency}
                                            style={'currency'}
                                        />
                                    </div>
                                </div> : ''
                            }
                            {
                                (this.state.invoiceId && this.state.returnIdentifier) &&
                                <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="return">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.return_label"
                                            defaultMessage="Return"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10 d-flex align-items-center">
                                        <a href={'#'} onClick={() => this.closeModalAndRedirect(this.state.invoiceId, 'returns')}>
                                            {this.state.returnIdentifier}
                                        </a>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.quoteId && this.state.quoteIdentifier) &&
                                <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="quote">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.quote_label"
                                            defaultMessage="Quote"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10 d-flex align-items-center">
                                        <a href={'#'} onClick={() => this.closeModalAndRedirect(this.state.quoteId, 'quotes')}>
                                            {this.state.quoteIdentifier}
                                        </a>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.orderId && this.state.orderIdentifier) &&
                                <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="order">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.order_label"
                                            defaultMessage="Order"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10 d-flex align-items-center">
                                        <a href={'#'} onClick={() => this.closeModalAndRedirect(this.state.orderId, 'orders')}>
                                            {this.state.orderIdentifier}
                                        </a>
                                    </div>
                                </div>
                            }

                            {
                                (this.state.appliedReferences.length > 0) &&
                                <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="quote">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.transactions_label"
                                            defaultMessage="Transactions"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10">
                                        <div className="row">
                                            <div className={"col-12"}>
                                                <StandardList
                                                    smallLine={true}
                                                    className="row pt-0"
                                                    headers={this.getTransactionHeaders()}
                                                    rows={this.getTransactionRows()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                this.state.creditMemoOriginalPayment &&
                                <div className="form-group row mb-0">
                                    <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="quote">
                                        <FormattedMessage
                                            id="invoice.credit_memo_modal.original_payment_label"
                                            defaultMessage="Original payment"
                                        />
                                    </label>
                                    <div className="col-12 col-md-10 d-flex align-items-center">
                                        <div className="border rounded my-2 w-100 p-2">
                                            {this.displayCreditMemoOriginalPaymentInformation()}
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                AppContext.getUserLoggedIn().attributes.superUser && this.state.links.length === 0 ?
                                    <div className="form-group row mb-0">
                                        <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="export">
                                            <ActionButton className={"btn btn-sm btn-outline-primary"} onClick={this.exportIntegration}>
                                                <Icon value={"cloud-upload-alt"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="payment_transaction.analytics.integration_export_btn"
                                                    defaultMessage="Export"
                                                />
                                            </ActionButton>
                                        </label>
                                        <div className="col-12 col-md-10">
                                            <div className="row">
                                                <div className={"col-12"}>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    : null
                            }

                            {
                                this.state.links.map(link => {
                                    let url = Integrations.getPaymentTransactionExternalUrl(link)
                                    let message = Integrations.getPaymentTransactionMessage(link.attributes.integrationKey)

                                    let cta = Integrations.getPaymentTransactionButtonLabel(link.attributes.integrationKey)
                                    return <div className={'row px-3'} key={link.id}>
                                        <blockquote className={'col-12 pt-2 mt-2'}>
                                            <div className={'w-100'}>
                                                <p className={'mb-2'}>
                                                    {message}
                                                </p>
                                            </div>
                                            <div className={'w-100 d-flex align-items-start flex-wrap'}>
                                                <div className={'mr-3'}>
                                                    <a href={url} target="_blank">
                                                        {Integrations.getIntegrationLogoImage(link.attributes.integrationKey, '75')}
                                                    </a>
                                                </div>
                                                <div >
                                                    <p className={'mb-0'}>
                                                        <a href={url} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                                                            {cta}
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </blockquote>
                                    </div>
                                })
                            }
                        </div>
                    </div>

                    <div className="modal-footer d-flex justify-content-between">
                        <div>
                            {
                                !this.state.readOnly &&
                                this.showActionButtons(this.state.isArchived)
                            }
                            {this.state.isArchived && <>
                                <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchiveCreditMemo} >
                                    <FormattedMessage
                                        id="quote.edit.status.unarchive_btn"
                                        defaultMessage="Unarchive"
                                    />
                                </ActionButton>
                            </>

                            }
                        </div>
                        {!this.state.isArchived && <div>
                            <button type="button" className="btn btn-secondary mr-2" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="invoice.void_modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                            {!this.state.readOnly &&
                                <ActionButton
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.submit}
                                >
                                    <FormattedMessage
                                        id="invoice.credit_memo_modal.save_btn"
                                        defaultMessage="Save"
                                    />
                                </ActionButton>
                            }
                        </div>}

                        {this.state.isArchived && <div>
                            <p className="text-align-right text-warning m-0">
                                <FormattedMessage
                                    id="invoice.credit_memo_modal.is_archive_message"
                                    defaultMessage="This credit memo is archived."
                                />
                            </p>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(EditCreditMemoModal)



// WEBPACK FOOTER //
// ./src/invoice/editcreditmemomodal.component.jsx